const IconTooltip = ({ width = 24, height = 25, fill = "#252525" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_15617_48695)">
        <path
          d="M7 20.4766H11C11 21.5766 10.1 22.4766 9 22.4766C7.9 22.4766 7 21.5766 7 20.4766ZM5 19.4766H13V17.4766H5V19.4766ZM16.5 9.97656C16.5 13.7966 13.84 15.8366 12.73 16.4766H5.27C4.16 15.8366 1.5 13.7966 1.5 9.97656C1.5 5.83656 4.86 2.47656 9 2.47656C13.14 2.47656 16.5 5.83656 16.5 9.97656ZM14.5 9.97656C14.5 6.94656 12.03 4.47656 9 4.47656C5.97 4.47656 3.5 6.94656 3.5 9.97656C3.5 12.4466 4.99 13.8666 5.85 14.4766H12.15C13.01 13.8666 14.5 12.4466 14.5 9.97656ZM21.37 7.84656L20 8.47656L21.37 9.10656L22 10.4766L22.63 9.10656L24 8.47656L22.63 7.84656L22 6.47656L21.37 7.84656ZM19 6.47656L19.94 4.41656L22 3.47656L19.94 2.53656L19 0.476562L18.06 2.53656L16 3.47656L18.06 4.41656L19 6.47656Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_15617_48695">
          <rect
            width="24"
            height="24"
            fill="none"
            transform="translate(0 0.476562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconTooltip;
